const resources = {
    shopThisPost: 'Découvrir cette publication'
};

module.exports = function getResource(label) {
    return resources[label];
};
